import { http } from "./http";
import {
  AttachUserToQuoteRequest,
  BuildProductQuoteRequest,
  BuildProductQuoteResponse,
  CreateQuoteRequest,
  CreateQuoteResponse,
} from "@/types/api/quote";

export async function buildProductQuote(req: BuildProductQuoteRequest): Promise<BuildProductQuoteResponse[]> {
  return http.post<BuildProductQuoteResponse[]>("/api/quote/product-recommendation", req);
}

export async function createQuote(req: CreateQuoteRequest): Promise<CreateQuoteResponse> {
  return http.post<CreateQuoteResponse>("/api/quote/create", req);
}

export async function attachUserToQuote(req: AttachUserToQuoteRequest): Promise<void> {
  return http.patch<void>("/api/quote/attach-user", req);
}
